import type { Color } from "@corca/data";

export const LABEL_COLORS: Color[] = [
  "blue-500",
  "red-500",
  "green-500",
  "orange-500",
  "purple-500",
  "yellow-500",
];
